import React from "react";
import Dashboard from "../layouts/Dashboard/Dashboard.jsx";
import LoginView from "../views/Login/LoginForm/Login.view.js";
import ForgotPasswordView from "../views/Login/ForgotPassword/ForgotPassword.view.js";
import ResetPassword from "../views/Login/ResetPassword/ResetPassword.view.js";
import ForgotPasswordSuccessView from "../views/Login/ForgotPassword/ForgotPasswordSuccessView";
import ResetPasswordSuccessView from "../views/Login/ResetPassword/ResetPasswordSuccessView";
import ResetPasswordExpiredView from "../views/Login/ResetPassword/ResetPasswordExpiredView";
import { Route, Switch } from "react-router-dom";

const RouteComponent = () => (
  <Switch>
    <Route exact path="/login" component={LoginView} />

    <Route exact path="/forgot-password" component={ForgotPasswordView} />

    <Route exact path="/password/reset" component={ResetPassword} />

    <Route
      exact
      path="/forgot-password-success"
      component={ForgotPasswordSuccessView}
    />

    <Route
      exact
      path="/password/reset/success"
      component={ResetPasswordSuccessView}
    />

    <Route
      exact
      path="/password/reset/expired"
      component={ResetPasswordExpiredView}
    />

    <Route path="/" component={Dashboard} />
  </Switch>
);

export default RouteComponent;